export const constants = {
  hmacKey: 'G3wSAJFW9XwDrEes',
  // These map to PropertiesCategoryTable.java in legacy
  moduleActionIds: {
    business: 23,
    environmental: 9,
    incident: 7,
    risk: 4,
    propertyManagement: 61
  },

  moduleIds: {
    health: 1,
    incident: 2,
    environment: 3,
    business: 22,
    propertyManagement: 60
  },

  /** Stores the register IDs that are currently valid to sync down to the app. */
  registerIds: {
    fireDoors: 63,
    asbestos: 64
  },

  registerNames: {
    fireDoors: 'FireDoor',
    asbestos: 'Asbestos'
  },

  /** Stores the IDs of default property fields used in conditional logic. */
  propertyDefaultIds: {
    country: 272,
    geographicalArea: 278
  },

  /** Stores the names of the default enum group fields that can be used to trigger conditional logic. */
  inspectionDefaultNames: {
    inspectionTypeName: 'moduleRecordTypeId',
    inspectionWillBeName: 'dueForReview'
  },

  /** Stores the IDs of the values that the default Inspection Will Be field, can be. */
  inspectionWillBe: {
    dueForReview: 273,
    oneOffInspection: 274
  },

  /** Told by Wez that default event fields will always have an ID less than 10000. */
  eventDefaultFieldIdThreshold: 10000,

  /** The ID of the default option that the review status select question should be set to on opening. */
  idOfNotReviewed: 4084,
  /** The ID of the shared action between register items option that is set by default. */
  idOfSharedActionOption: 1,

  /** The ID of the incident type question that is in all incident forms, default tab, using the same ID. */
  incidentTypeQuestionId: 4,
  /** The ID of the default attach files question that is in all incident forms, default tab, using the same ID every time. */
  defaultAttachFilesQuestionId: 10,
  /** The maximum number of files that can be attached to incident file questions (not the default file question). */
  incidentFileQuestionLimit: 10,
  /** The maximum number of files that can be attached to the default incident file question. */
  defaultIncidentFileQuestionLimit: 10,
  /** The maximum number of properties that can be selected at any one time to sync. */
  maxSelectableProperties: 5,
  /** Defines the client ID for JLL. */
  JLLClientId: '2020',
  /** Defined the maximum audit file limit that is used if the fileLimit has not been defined yet
   * (i.e. after upgrade and before sync).
   */
  maxAuditFileLimit: 5,
  /** Defines the default file limit for audit file upload type questions. */
  auditFileTypeDefaultLimit: 2,
  /** Defines the default file limit for audit table file upload type questions. */
  auditTableFileTypeDefaultLimit: 1,
  /** Defines that maximum number of files that can be attached to general event register image upload fields. */
  maxRegisterEventFileLimit: 1,
  /** Defines the maximum number of files that can be attached to the default attachFiles image upload field.  */
  maxRegisterEventDefaultFileLimit: 10,
  /** Defines the maximum number of files that can be attached when completing an action with on an inspection or an outstanding action. */
  maxActionCompletionFileLimit: 10,
  /** Defines the maximum amount of characters for the notes textarea of an Inspection. */
  inspectionNoteCharacterLimit: 3000,
  /** Defines the maximum amount of characters for the textareas on an Action. */
  actionCharacterLimit: 7500,
  /** Defines the key used to get the biometrics credentials linked to identities saved on the device. */
  biometricsServerKey: 'riskwise-biometrics',
  /** Defines the maximum amount of scheduled inspections that are allowed before a loading icon is used to open the list view.*/
  maxSchedulesInspections: 200,
  /** Defines a file size limit in MB for all files attached anywhere in the app.*/
  maxFileSizeLimit: 50,
  /** Defines the number of milliseconds in one day. */
  millisecondsInOneDay: 86400000,
  /** Defines the maximum amount of conditional logic chaining recursions allowed before exiting out. */
  recursiveCountLimit: 300
};

/** Stores the current translation JSON object which is accessed by the
 * app to define key strings.
 */
export const translationObject = {
  currentTranslation: null
};
